import * as React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import Box from "@sproutsocial/seeds-react-box";
import type { TypeModalDescriptionProps } from "../ModalTypes";

/**
 * Modal description component that wraps content with accessible Dialog.Description.
 *
 * This component automatically connects description text to the modal dialog via ARIA attributes,
 * ensuring screen readers announce the description when the modal opens. Use this for additional
 * context beyond the title that helps users understand the modal's purpose.
 *
 * @example
 * <ModalDescription>
 *   Deleting this item will permanently remove it from your account.
 * </ModalDescription>
 */
export const ModalDescription = React.forwardRef<
  HTMLDivElement,
  TypeModalDescriptionProps
>(({ children, descriptionProps = {}, ...rest }, ref) => {
  return (
    <Dialog.Description asChild {...descriptionProps}>
      <Box
        data-slot="modal-description"
        data-qa-modal-description
        ref={ref}
        {...rest}
      >
        {children}
      </Box>
    </Dialog.Description>
  );
});

ModalDescription.displayName = "ModalDescription";
